import { graphql, useStaticQuery } from 'gatsby'
import { INewsItem } from '../types'
import { AppRegionEnum } from '../types/app-region.enum'

export const useBlogData = (region: AppRegionEnum): INewsItem[] => {
  const images = useStaticQuery(imagesQuery)
  const news: Record<AppRegionEnum, INewsItem[]> = {
    [AppRegionEnum.Ru]: [
      {
        id: '__ANALITIKA-DANNYH-V-STROITELSTVE__',
        title:
          'Аналитика данных в\u00a0строительстве: как улучшить процессы и повысить эффективность в проектах',
        to: '/blog/analitika-dannyh-v-stroitelstve/',
        image:
          images.analitika_dannyh_v_stroitelstve.childImageSharp
            .gatsbyImageData,
      },
      {
        id: '__INOVACII-V-STROITELSTVE__',
        title:
          'Инновации в строительстве. Передовые технологии в помощь проектам',
        to: '/blog/inovacii-v-stroitelstve/',
        image: images.inovacii_v_stroitelstve.childImageSharp.gatsbyImageData,
      },
      {
        id: '__PROGRAMMA-DLYA-UPRAVLENYA-STROITELSTVOM__',
        title:
          'Программное обеспечение для управления строительством. Ведем проекты по новому ',
        to: '/blog/programma-dlya-upravlenya-stroitelstvom/',
        image:
          images.programma_dlya_upravlenya_stroitelstvom.childImageSharp
            .gatsbyImageData,
      },
      {
        id: '__6-PRICHIN-ISPOLSOVAT-INSPECTION__',
        title:
          '6 причин цифровизации строительного контроля с SIGNAL INSPECTION',
        to: '/blog/6-prichin-ispolsovat-inspection/',
        image:
          images.prichiny_ispolsovat_inspection.childImageSharp.gatsbyImageData,
      },
    ],
    [AppRegionEnum.Us]: [],
  }

  return news[region]
}

const imagesQuery = graphql`
  query {
    analitika_dannyh_v_stroitelstve: file(
      relativePath: { eq: "blog/analitika-dannyh-v-stroitelstve/preview.png" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 716, placeholder: BLURRED)
      }
    }
    inovacii_v_stroitelstve: file(
      relativePath: { eq: "blog/inovacii-v-stroitelstve/preview.png" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 716, placeholder: BLURRED)
      }
    }
    programma_dlya_upravlenya_stroitelstvom: file(
      relativePath: {
        eq: "blog/programma-dlya-upravlenya-stroitelstvom/preview.png"
      }
    ) {
      childImageSharp {
        gatsbyImageData(width: 716, placeholder: BLURRED)
      }
    }
    prichiny_ispolsovat_inspection: file(
      relativePath: { eq: "blog/6-prichin-ispolsovat-inspection/preview.png" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 716, placeholder: BLURRED)
      }
    }
  }
`
